import React from 'react'
import { Link } from 'react-router-dom'
import FavoriteComponent from '../FavoriteComponent/FavoriteComponent'


function CardPost({ title, img, category, description, id, specialty, isPremium }) {
    return (
        <div className="p-4 md:w-1/3">
            <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden duration-200 shadow-lg hover:shadow-2xl">
                <div className="relative ">
                    <img className="lg:h-48 md:h-36 w-full object-cover object-center relative" src={img} alt="blog" ></img>{isPremium
                        ? <div className="bg-gradient-to-r from-yellow-300 to-yellow-500 text-black md:w-1/4 sm:w-1/2 text-center rounded-r-xl p-2 font-medium absolute top-0 left-0 p-2">Premium</div>
                        : <span></span>
                    }
                    <div className="absolute button-0 right-0 p-2 ">
                        <FavoriteComponent id={id} img={img} title={title} />
                    </div>
                </div>
                {/* {isPremium
                    ? <div className="bg-gradient-to-r from-yellow-300 to-yellow-500 text-black w-1/4 text-center rounded-r-xl p-2 font-medium">Premium</div>
                    : <span></span>
                } */}
                <Link to={`/posts/${id}`}>
                    <div className="p-6">

                        <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">{category.title}</h2>
                        <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">{specialty.title}</h2>
                        <h1 className="title-font text-lg font-medium text-gray-900 mb-3">{title}</h1>
                        <p className="leading-relaxed mb-3">{description}</p>
                        <div className="flex items-center flex-wrap relative">
                            {/* <span className="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0 hover:text-indigo-700 absolute -left-2 -bottom-2">Ver mas
                                <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5l7 7-7 7"></path>
                                </svg>

                            </span> */}
                            {/* <span className="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200">
                                <svg className="w-4 h-4 mr-1" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                    <circle cx="12" cy="12" r="3"></circle>
                                </svg>1.2K
                                </span>
                                <span className="text-gray-400 inline-flex items-center leading-none text-sm">
                                <svg className="w-4 h-4 mr-1" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                                </svg>6
                            </span> */}
                        </div>
                    </div>
                </Link>

            </div>
        </div>
    )
}

export default CardPost
